"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Evexia API
 * OpenAPI Spec for Evexia APIs
 *
 * The version of the OpenAPI document: 1.0
 * Contact: ch_engineering@calm.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RewardApi = exports.RewardApiFactory = exports.RewardApiFp = exports.RewardApiAxiosParamCreator = void 0;
const tslib_1 = require("tslib");
const axios_1 = tslib_1.__importDefault(require("axios"));
// @ts-ignore
const base_1 = require("../base");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
/**
 * RewardApi - axios parameter creator
 */
const RewardApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * v1 Admin Create Rewards creates rewards. This endpoint is for internal admin use only.  **Admin Access Required**: This endpoint requires admin permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary v1 Admin Create Rewards (Admin Only)
         * @param {RewardAdminRewardsRequest} [rewardAdminRewardsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminCreateRewards: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ rewardAdminRewardsRequest }, options = {}) {
            const localVarPath = `/v1/rewards/admin/rewards`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/rewards/admin/rewards`,
                sdkMethod: 'v1AdminCreateRewards',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rewardAdminRewardsRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * v1 Admin Delete Recipient Reward deletes a specific reward for a recipient.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary v1 Admin Delete Recipient Reward
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} rewardId The ID of the reward
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminDeleteRecipientReward: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ recipientId, rewardId }, options = {}) {
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v1AdminDeleteRecipientReward', 'recipientId', recipientId);
            // verify required parameter 'rewardId' is not null or undefined
            (0, common_1.assertParamExists)('v1AdminDeleteRecipientReward', 'rewardId', rewardId);
            const localVarPath = `/v1/rewards/admin/recipients/{recipient_id}/rewards/{reward_id}`
                .replace('{recipient_id}', encodeURIComponent(String(recipientId)))
                .replace('{reward_id}', encodeURIComponent(String(rewardId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/rewards/admin/recipients/{recipient_id}/rewards/{reward_id}`,
                sdkMethod: 'v1AdminDeleteRecipientReward',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * v1 Admin Remove Rewards removes rewards. This endpoint is for internal admin use only.  **Admin Access Required**: This endpoint requires admin permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary v1 Admin Remove Rewards (Admin Only)
         * @param {RewardAdminRewardsRequest} [rewardAdminRewardsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminRemoveRewards: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ rewardAdminRewardsRequest }, options = {}) {
            const localVarPath = `/v1/rewards/admin/rewards`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/rewards/admin/rewards`,
                sdkMethod: 'v1AdminRemoveRewards',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rewardAdminRewardsRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * v1 Get Admin Recipient Rewards returns all rewards for a specific recipient including soft-deleted rewards.  **Admin Access Required**: This endpoint requires admin permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary v1 Get Admin Recipient Rewards (Admin Only)
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} [limit] Limit for pagination
         * @param {number} [offset] Offset for pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GetAdminRecipientRewards: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ recipientId, limit, offset }, options = {}) {
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v1GetAdminRecipientRewards', 'recipientId', recipientId);
            const localVarPath = `/v1/rewards/admin/recipients/{recipient_id}/rewards`.replace('{recipient_id}', encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/rewards/admin/recipients/{recipient_id}/rewards`,
                sdkMethod: 'v1GetAdminRecipientRewards',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * v1 Get Admin Rewards returns a list of rewards. This endpoint is for internal admin use only.  **Admin Access Required**: This endpoint requires admin permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary v1 Get Admin Rewards (Admin Only)
         * @param {Array<string>} [affiliatePartner] Partner IDs to filter rewards for
         * @param {boolean} [includeRedeemed] Include redeemed rewards in the response
         * @param {boolean} [includeDeleted] Include deleted rewards in the response
         * @param {number} [limit] Limit for pagination
         * @param {number} [offset] Offset for pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GetAdminRewards: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ affiliatePartner, includeRedeemed, includeDeleted, limit, offset, }, options = {}) {
            const localVarPath = `/v1/rewards/admin/rewards`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (affiliatePartner) {
                localVarQueryParameter['affiliatePartner'] = affiliatePartner;
            }
            if (includeRedeemed !== undefined) {
                localVarQueryParameter['includeRedeemed'] = includeRedeemed;
            }
            if (includeDeleted !== undefined) {
                localVarQueryParameter['includeDeleted'] = includeDeleted;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/rewards/admin/rewards`,
                sdkMethod: 'v1GetAdminRewards',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns the rewards details page configuration including available partner rewards and benefits. This endpoint returns static configuration data and does not filter by user eligibility.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
         * @summary Get rewards details page configuration
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GetRecipientRewardsDetails: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ recipientId, circleAuthorizationToken, acceptLanguage, }, options = {}) {
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v1GetRecipientRewardsDetails', 'recipientId', recipientId);
            const localVarPath = `/v1/rewards/recipients/{recipient_id}/rewards/details`.replace('{recipient_id}', encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'application/json';
            if (circleAuthorizationToken != null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            if (acceptLanguage != null) {
                localVarHeaderParameter['Accept-Language'] =
                    String(acceptLanguage);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/rewards/recipients/{recipient_id}/rewards/details`,
                sdkMethod: 'v1GetRecipientRewardsDetails',
            };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * v1 Redeem Recipient Reward marks a reward as redeemed/used for a recipient. Optionally sends an email notification to the recipient.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary v1 Redeem Recipient Reward
         * @param {number} recipientId A ID of the recipient self circle
         * @param {RewardRedeemRewardRequest} rewardRedeemRewardRequest
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RedeemRecipientReward: (_a, ...args_1) => tslib_1.__awaiter(this, [_a, ...args_1], void 0, function* ({ recipientId, rewardRedeemRewardRequest, circleAuthorizationToken, }, options = {}) {
            // verify required parameter 'recipientId' is not null or undefined
            (0, common_1.assertParamExists)('v1RedeemRecipientReward', 'recipientId', recipientId);
            // verify required parameter 'rewardRedeemRewardRequest' is not null or undefined
            (0, common_1.assertParamExists)('v1RedeemRecipientReward', 'rewardRedeemRewardRequest', rewardRedeemRewardRequest);
            const localVarPath = `/v1/rewards/recipients/{recipient_id}/rewards`.replace('{recipient_id}', encodeURIComponent(String(recipientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';
            if (circleAuthorizationToken != null) {
                localVarHeaderParameter['Circle-Authorization-Token'] = String(circleAuthorizationToken);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions._metadata = {
                urlPattern: `/v1/rewards/recipients/{recipient_id}/rewards`,
                sdkMethod: 'v1RedeemRecipientReward',
            };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rewardRedeemRewardRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.RewardApiAxiosParamCreator = RewardApiAxiosParamCreator;
/**
 * RewardApi - functional programming interface
 */
const RewardApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.RewardApiAxiosParamCreator)(configuration);
    return {
        /**
         * v1 Admin Create Rewards creates rewards. This endpoint is for internal admin use only.  **Admin Access Required**: This endpoint requires admin permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary v1 Admin Create Rewards (Admin Only)
         * @param {RewardAdminRewardsRequest} [rewardAdminRewardsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminCreateRewards(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AdminCreateRewards(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RewardApi.v1AdminCreateRewards']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * v1 Admin Delete Recipient Reward deletes a specific reward for a recipient.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary v1 Admin Delete Recipient Reward
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} rewardId The ID of the reward
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminDeleteRecipientReward(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AdminDeleteRecipientReward(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RewardApi.v1AdminDeleteRecipientReward']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * v1 Admin Remove Rewards removes rewards. This endpoint is for internal admin use only.  **Admin Access Required**: This endpoint requires admin permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary v1 Admin Remove Rewards (Admin Only)
         * @param {RewardAdminRewardsRequest} [rewardAdminRewardsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminRemoveRewards(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1AdminRemoveRewards(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RewardApi.v1AdminRemoveRewards']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * v1 Get Admin Recipient Rewards returns all rewards for a specific recipient including soft-deleted rewards.  **Admin Access Required**: This endpoint requires admin permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary v1 Get Admin Recipient Rewards (Admin Only)
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} [limit] Limit for pagination
         * @param {number} [offset] Offset for pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GetAdminRecipientRewards(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1GetAdminRecipientRewards(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RewardApi.v1GetAdminRecipientRewards']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * v1 Get Admin Rewards returns a list of rewards. This endpoint is for internal admin use only.  **Admin Access Required**: This endpoint requires admin permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary v1 Get Admin Rewards (Admin Only)
         * @param {Array<string>} [affiliatePartner] Partner IDs to filter rewards for
         * @param {boolean} [includeRedeemed] Include redeemed rewards in the response
         * @param {boolean} [includeDeleted] Include deleted rewards in the response
         * @param {number} [limit] Limit for pagination
         * @param {number} [offset] Offset for pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GetAdminRewards(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1GetAdminRewards(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RewardApi.v1GetAdminRewards']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * Returns the rewards details page configuration including available partner rewards and benefits. This endpoint returns static configuration data and does not filter by user eligibility.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
         * @summary Get rewards details page configuration
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GetRecipientRewardsDetails(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1GetRecipientRewardsDetails(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RewardApi.v1GetRecipientRewardsDetails']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * v1 Redeem Recipient Reward marks a reward as redeemed/used for a recipient. Optionally sends an email notification to the recipient.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary v1 Redeem Recipient Reward
         * @param {number} recipientId A ID of the recipient self circle
         * @param {RewardRedeemRewardRequest} rewardRedeemRewardRequest
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RedeemRecipientReward(params, options) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1RedeemRecipientReward(params, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RewardApi.v1RedeemRecipientReward']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.RewardApiFp = RewardApiFp;
/**
 * RewardApi - factory interface
 */
const RewardApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.RewardApiFp)(configuration);
    return {
        /**
         * v1 Admin Create Rewards creates rewards. This endpoint is for internal admin use only.  **Admin Access Required**: This endpoint requires admin permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary v1 Admin Create Rewards (Admin Only)
         * @param {RewardAdminRewardsRequest} [rewardAdminRewardsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminCreateRewards(params, options) {
            return localVarFp
                .v1AdminCreateRewards(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * v1 Admin Delete Recipient Reward deletes a specific reward for a recipient.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary v1 Admin Delete Recipient Reward
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} rewardId The ID of the reward
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminDeleteRecipientReward(params, options) {
            return localVarFp
                .v1AdminDeleteRecipientReward(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * v1 Admin Remove Rewards removes rewards. This endpoint is for internal admin use only.  **Admin Access Required**: This endpoint requires admin permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary v1 Admin Remove Rewards (Admin Only)
         * @param {RewardAdminRewardsRequest} [rewardAdminRewardsRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AdminRemoveRewards(params, options) {
            return localVarFp
                .v1AdminRemoveRewards(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * v1 Get Admin Recipient Rewards returns all rewards for a specific recipient including soft-deleted rewards.  **Admin Access Required**: This endpoint requires admin permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary v1 Get Admin Recipient Rewards (Admin Only)
         * @param {number} recipientId A ID of the recipient self circle
         * @param {number} [limit] Limit for pagination
         * @param {number} [offset] Offset for pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GetAdminRecipientRewards(params, options) {
            return localVarFp
                .v1GetAdminRecipientRewards(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * v1 Get Admin Rewards returns a list of rewards. This endpoint is for internal admin use only.  **Admin Access Required**: This endpoint requires admin permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary v1 Get Admin Rewards (Admin Only)
         * @param {Array<string>} [affiliatePartner] Partner IDs to filter rewards for
         * @param {boolean} [includeRedeemed] Include redeemed rewards in the response
         * @param {boolean} [includeDeleted] Include deleted rewards in the response
         * @param {number} [limit] Limit for pagination
         * @param {number} [offset] Offset for pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GetAdminRewards(params, options) {
            return localVarFp
                .v1GetAdminRewards(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * Returns the rewards details page configuration including available partner rewards and benefits. This endpoint returns static configuration data and does not filter by user eligibility.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
         * @summary Get rewards details page configuration
         * @param {number} recipientId A ID of the recipient self circle
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1GetRecipientRewardsDetails(params, options) {
            return localVarFp
                .v1GetRecipientRewardsDetails(params, options)
                .then((request) => request(axios, basePath));
        },
        /**
         * v1 Redeem Recipient Reward marks a reward as redeemed/used for a recipient. Optionally sends an email notification to the recipient.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
         * @summary v1 Redeem Recipient Reward
         * @param {number} recipientId A ID of the recipient self circle
         * @param {RewardRedeemRewardRequest} rewardRedeemRewardRequest
         * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RedeemRecipientReward(params, options) {
            return localVarFp
                .v1RedeemRecipientReward(params, options)
                .then((request) => request(axios, basePath));
        },
    };
};
exports.RewardApiFactory = RewardApiFactory;
/**
 * RewardApi - object-oriented interface
 */
class RewardApi extends base_1.BaseAPI {
    /**
     * URL `/v1/rewards/admin/rewards`
     * v1 Admin Create Rewards creates rewards. This endpoint is for internal admin use only.  **Admin Access Required**: This endpoint requires admin permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary v1 Admin Create Rewards (Admin Only)
     * @param {RewardAdminRewardsRequest} [rewardAdminRewardsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v1AdminCreateRewards(params, options) {
        return (0, exports.RewardApiFp)(this.configuration)
            .v1AdminCreateRewards(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/rewards/admin/recipients/{recipient_id}/rewards/{reward_id}`
     * v1 Admin Delete Recipient Reward deletes a specific reward for a recipient.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary v1 Admin Delete Recipient Reward
     * @param {number} recipientId A ID of the recipient self circle
     * @param {number} rewardId The ID of the reward
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v1AdminDeleteRecipientReward(params, options) {
        return (0, exports.RewardApiFp)(this.configuration)
            .v1AdminDeleteRecipientReward(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/rewards/admin/rewards`
     * v1 Admin Remove Rewards removes rewards. This endpoint is for internal admin use only.  **Admin Access Required**: This endpoint requires admin permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary v1 Admin Remove Rewards (Admin Only)
     * @param {RewardAdminRewardsRequest} [rewardAdminRewardsRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v1AdminRemoveRewards(params, options) {
        return (0, exports.RewardApiFp)(this.configuration)
            .v1AdminRemoveRewards(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/rewards/admin/recipients/{recipient_id}/rewards`
     * v1 Get Admin Recipient Rewards returns all rewards for a specific recipient including soft-deleted rewards.  **Admin Access Required**: This endpoint requires admin permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary v1 Get Admin Recipient Rewards (Admin Only)
     * @param {number} recipientId A ID of the recipient self circle
     * @param {number} [limit] Limit for pagination
     * @param {number} [offset] Offset for pagination
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v1GetAdminRecipientRewards(params, options) {
        return (0, exports.RewardApiFp)(this.configuration)
            .v1GetAdminRecipientRewards(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/rewards/admin/rewards`
     * v1 Get Admin Rewards returns a list of rewards. This endpoint is for internal admin use only.  **Admin Access Required**: This endpoint requires admin permissions.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary v1 Get Admin Rewards (Admin Only)
     * @param {Array<string>} [affiliatePartner] Partner IDs to filter rewards for
     * @param {boolean} [includeRedeemed] Include redeemed rewards in the response
     * @param {boolean} [includeDeleted] Include deleted rewards in the response
     * @param {number} [limit] Limit for pagination
     * @param {number} [offset] Offset for pagination
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v1GetAdminRewards(params, options) {
        return (0, exports.RewardApiFp)(this.configuration)
            .v1GetAdminRewards(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/rewards/recipients/{recipient_id}/rewards/details`
     * Returns the rewards details page configuration including available partner rewards and benefits. This endpoint returns static configuration data and does not filter by user eligibility.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | circle | r |
     * @summary Get rewards details page configuration
     * @param {number} recipientId A ID of the recipient self circle
     * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
     * @param {string} [acceptLanguage] This header indicates the user\&#39;s preferred language. If the language is not supported, content will be served in English by default.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v1GetRecipientRewardsDetails(params, options) {
        return (0, exports.RewardApiFp)(this.configuration)
            .v1GetRecipientRewardsDetails(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL `/v1/rewards/recipients/{recipient_id}/rewards`
     * v1 Redeem Recipient Reward marks a reward as redeemed/used for a recipient. Optionally sends an email notification to the recipient.  |Feature|Dataclass|Permission| |-------|---------|----------| | - | - | - |
     * @summary v1 Redeem Recipient Reward
     * @param {number} recipientId A ID of the recipient self circle
     * @param {RewardRedeemRewardRequest} rewardRedeemRewardRequest
     * @param {string} [circleAuthorizationToken] Circle JWT token that contains user\&#39;s role and circle information. Not required for admin users.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v1RedeemRecipientReward(params, options) {
        return (0, exports.RewardApiFp)(this.configuration)
            .v1RedeemRecipientReward(params, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
exports.RewardApi = RewardApi;
//# sourceMappingURL=reward-api.js.map